import { useListServerlessTasks } from '@/service/serverless-gpu/hook';
import { WrapTableAndSheet } from '../../../tasks/tasks';
import {
  StatusServerlessTask,
  TypeServerless,
} from '@/service/serverless-gpu/type';
import { useParams } from 'react-router-dom';
import { RouteParams } from '@/router/type';
import { compareDateDesc } from '@/utils/date';

const TableSpotTasks = () => {
  const { projectId } = useParams<RouteParams>();

  const { data, isLoading } = useListServerlessTasks({
    project_id: projectId,
    trigger_type: TypeServerless.Spot,
  },{
    refetchInterval: 1000 * 60
  });

  const tasks =
    data?.tasks
      ?.filter(
        (item) =>
          [TypeServerless.Spot].includes(
            item.trigger_type
          ) &&
          [StatusServerlessTask.Running, StatusServerlessTask.Pending, StatusServerlessTask.WaitingForResource].includes(
            item.status
          )
      )
      .sort(compareDateDesc('created_at')) || [];
  return (
    <WrapTableAndSheet
      data={tasks?.map((item) => ({
        id: item.id,
        status: item.status,
        name: item.name,
        created_at: item.created_at,
        type: item.trigger_type,
      }))}
      isLoading={isLoading}
    />
  );
};

export default TableSpotTasks;
